import { render, staticRenderFns } from "./VisibilityForm.vue?vue&type=template&id=a221bf6c&scoped=true&"
import script from "./VisibilityForm.vue?vue&type=script&lang=js&"
export * from "./VisibilityForm.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/forms.css?vue&type=style&index=0&id=a221bf6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a221bf6c",
  null
  
)

export default component.exports